import { useRouter } from "next/router";
import { Field, FormOptions } from "tinacms";
import { Art, LOCALE_OPTIONS } from "../common/lib/api/base";
import { MapOf, toNatural } from "../common/lib/utils";

const fields = [
  "name",
  "description",
  "reserve_price",
  "alt_text",
  "audio_description",
  "mainpage_auction",
] as const;

const FIELDS_COMPONENT_MAP: MapOf<string> = {
  mainpage_auction: "toggle",
};

type RESULT_KEYS = typeof fields[number] | "tags";

type FORM_RESULT = {
  [key in RESULT_KEYS]: key extends keyof Art ? NonNullable<Art[key]> : string;
};

export type ART_FORM_RESULT = FORM_RESULT;

type FORM_RETURN_TYPE = FormOptions<FORM_RESULT>;

type FORM_FIELD_DATA<T = any> = { label: string; value: T };

type FORM_FIELD = Field & {
  data?: Array<FORM_FIELD_DATA>;
  multi?: boolean;
};

const makeArtForm = (
  art: Art,
  overrides: Partial<FORM_RETURN_TYPE> = {}
): FORM_RETURN_TYPE => {
  const empty = [] as FORM_FIELD[];
  const { locale = "en" } = useRouter();
  const val = { ...art, ...art.overrides?.[locale as LOCALE_OPTIONS] };
  return {
    id: "",
    label: art.name || "",
    onSubmit: console.log,
    initialValues: {
      name: val?.name || art.name,
      description: val?.description || art.description,
      reserve_price: val?.reserve_price || "",
      tags: val?.tags || [],
      alt_text: val?.alt_text || "",
      audio_description: val?.audio_description || "",
      mainpage_auction: val?.mainpage_auction || "",
    },
    fields: empty.concat(
      {
        name: "tags",
        component: "tags",
        defaultValue: val?.tags || [],
      },
      fields.map((key) => {
        let component: string = "text";
        const value = art[key];
        if (value && value.toString().length > 40) component = "textarea";
        if (key in FIELDS_COMPONENT_MAP) component = FIELDS_COMPONENT_MAP[key];
        return {
          component,
          name: key,
          defaultValue: art[key],
          label: toNatural(key),
        };
      })
    ),
    ...overrides,
  };
};

export { makeArtForm };
